import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"

export interface RunModelDtoWrapper {
  items: RunModelDto[]
}

export interface RunModelDto {
  key: string
  graph_key: string
  parameters: string
  description: string
  dimensions: {
    year_end: string
    country: string
  }
  family_key: string
  scenario_key: string
  owner_group_key: string
  creation_date: string
  creator_email: string
  user_graph_key: string
  timesteps?: string[]
}

interface RunQuery {
  key: string
  seed: number
  numSamples: number
  samplingEngine: "EVIEWS"
  runName?: string
  contractKey?: string
}

export const modelsApi = createApi({
  reducerPath: "modelsApi",
  baseQuery: authQuery,
  endpoints: (builder) => ({
    getModels: builder.query<RunModelDtoWrapper, void>({
      query: () => ({
        url: "/models",
      }),
    }),
    getModel: builder.query<RunModelDto, string>({
      query: (key) => ({
        url: `/models/${key}`,
      }),
    }),
    getModelLagValues: builder.query<Record<string, number>, string>({
      // key is model uuid from results page
      query: (key) => ({
        url: `/models/${key}/lag-values`,
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
    getRunModel: builder.query<any, RunQuery>({
      query: (data) => {
        return data.contractKey !== undefined
          ? {
              url: `/models/${data.key}/run?seed=${data.seed}&num_samples=${
                data.numSamples
                }&sampling_engine=${data.samplingEngine}&contract_key=${encodeURIComponent(
                  data.contractKey,
                )}&run_name=${encodeURIComponent(data.runName || "")}`,
            }
          : {
              url: `/models/${data.key}/run?seed=${data.seed}&num_samples=${
                data.numSamples
                }&sampling_engine=${data.samplingEngine}&run_name=${encodeURIComponent(
                  data.runName || "",
                )}`,
            }
      },
    }),
    getModelJson: builder.query<string[], string>({
      query: (key) => ({
        url: `models/${key}/multistep`,
      }),
    }),
  }),
})

export const {
  useGetModelsQuery,
  useLazyGetRunModelQuery,
  useLazyGetModelQuery,
  useGetModelLagValuesQuery,
  useGetModelQuery,
  useLazyGetModelJsonQuery,
} = modelsApi
